@let localMarker = marker();

<article
  class="marker-card rounded-4 h-100 p-0 w-100"
  [class]="isCarousel() ? 'shadow-sm' : 'shadow-lg'"
  [class.mobile-single-column]="mobileColumns() === 1"
  role="link"
  tabindex="0"
  [attr.aria-label]="cardAriaLabel()"
  (click)="goToMarker()"
  (keydown.enter)="goToMarker()"
  (keydown.space)="onCardKeydown($event)"
>
  <!-- IMAGE HEADER SECTION -->
  <div class="card-image position-relative">
    <img
      [lazyLoad]="localMarker?.image | cdnUrl: 500 : true"
      [alt]="localMarker?.language?.name"
      class="w-100 h-100 object-fit-cover"
    />

    <!-- Badge "360° VR" (top left) -->
    @if (localMarker?.has_vr) {
      <span class="image-badge vr-badge" aria-hidden="true">360° VR</span>
    }

    <!-- Floating Action Bar (right side, vertically centered) -->
    @if (showBtnMap() || localMarker?.vr_video || localMarker?.vr_tour) {
      <div class="floating-actions" role="group" aria-label="Acciones del marcador">
        <!-- Location / Map Button -->
        @if (showBtnMap()) {
          <button
            type="button"
            class="floating-btn"
            (click)="goToMap(); $event.stopPropagation()"
            (keydown.enter)="$event.stopPropagation()"
            (keydown.space)="$event.stopPropagation()"
            aria-label="Ver ubicación en el mapa"
            title="Ubicación"
          >
            <img src="assets/img/icons/location_icon.svg" alt="" class="floating-icon" />
          </button>
        }
        <!-- 360 View Button -->
        @if (localMarker?.vr_video) {
          <button
            type="button"
            class="floating-btn"
            (click)="goToVR(); $event.stopPropagation()"
            (keydown.enter)="$event.stopPropagation()"
            (keydown.space)="$event.stopPropagation()"
            aria-label="Abrir vista 360°"
            title="Vista 360°"
          >
            <img src="assets/img/icons/360_icon.svg" alt="" class="floating-icon" />
          </button>
        }
        <!-- Tour / Walk Button -->
        @if (localMarker?.vr_tour) {
          <button
            type="button"
            class="floating-btn"
            (click)="goToTour(); $event.stopPropagation()"
            (keydown.enter)="$event.stopPropagation()"
            (keydown.space)="$event.stopPropagation()"
            aria-label="Iniciar recorrido virtual"
            title="Recorrido VR"
          >
            <i class="fa-solid fa-person-walking floating-icon-inm" aria-hidden="true"></i>
          </button>
        }
      </div>
    }
  </div>

  <!-- Duration badge (bottom left, overlapping the image edge) -->
  <span class="image-badge duration-badge" aria-hidden="true">3 DÍAS / 2 NOCHES</span>

  <!-- CARD CONTENT SECTION -->
  <div class="card-body d-flex flex-column">
    <div class="info">
      <!-- Title -->
      <h3 class="card-title-text">{{ localMarker.language?.name }}</h3>

      <!-- Location -->
      <p class="card-location-text">
        <i class="fa-solid fa-location-dot location-icon-small" aria-hidden="true"></i>
        <span class="location-name">{{ location() }}</span>
      </p>

      <!-- Rating & Valuations Row -->
      <div class="ratings-row">
        <div class="rating-badge">
          <span>{{ qualification() }}</span>
          <i class="fa-solid fa-star star-icon" aria-hidden="true"></i>
        </div>
        <span class="rating-count"
          >{{ localMarker?.valuations || 0 }} {{ '$valuations_text_plural' | translate }}</span
        >
      </div>

      @if (priceDetails().hasPrice && priceDetails().hasDiscount) {
        <!-- Discount Badges Row -->
        <div class="badges-row">
          @if (priceDetails().isSuperOffer) {
            <span class="offer-badge" aria-hidden="true">SUPER OFERTA</span>
          }
          <div class="savings-badge">
            <i class="fa-solid fa-tag tag-icon" aria-hidden="true"></i>
            <span>Ahorras {{ formatPrice(priceDetails().savings) }}</span>
          </div>
        </div>
      }
    </div>

    @if (priceDetails().hasPrice) {
      <!-- Price section -->
      <div class="price-section mt-auto">
        <span class="price-label">Desde</span>
        @if (priceDetails().hasDiscount) {
          <span class="price-old">{{ formatPrice(priceDetails().base) }}</span>
        }

        <div class="price-row">
          <span class="price-current">{{ formatPrice(priceDetails().current) }}</span>
        </div>

        <p class="disclaimer">{{ 'iva_included_label' | translate }}</p>
      </div>
    } @else {
      <div class="no-price-message">
        <button
          type="button"
          class="profile-button light-green"
          [attr.aria-label]="cardAriaLabel()"
          (click)="goToMarker(); $event.stopPropagation()"
          (keydown.enter)="$event.stopPropagation()"
          (keydown.space)="$event.stopPropagation()"
        >
          <span>Ver perfil</span>
          <i class="fa-solid fa-arrow-right" aria-hidden="true"></i>
        </button>
      </div>
    }
  </div>
</article>
